import React, { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';

const defaultStyles =
    'p-2 placeholder-gray-300 text-gray-700 relative bg-white rounded text-md border border-gray-300 outline-none focus:outline-none focus:ring w-full';

const EditableCell = ({
    value: initValue,
    row,
    column: { id },
    updateSelectedRow,
    errorMessages,
    showEdit,
    selectOptions,
}) => {
    const [value, setValue] = useState(initValue ? initValue : undefined);

    const onChange = (event) => {
        if (event?.value || (!event && id === 'customer')) {
            // it is select
            setValue(event?.value);
            updateSelectedRow('customer', event);
        } else if (event?.target?.name) {
            setValue(event.target.value);
            updateSelectedRow(event.target.name, event.target.value);
        } else {
            updateSelectedRow(null);
        }
    };

    const toggleValue = () => {
        const newValue = !value;
        setValue(newValue);
        updateSelectedRow(id, newValue);
    };

    useEffect(() => {
        setValue(initValue ? initValue : undefined);
    }, [initValue, showEdit]);

    const setCustomersSelectStyle = () => ({
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
        container: (provided) => ({
            ...provided,
        }),
        control: (provided, state) => ({
            ...provided,
            outline: 'none',
            boxShadow: 'none',
            border: 'solid 1px #DADDE8',

            backgroundColor: 'white',
            cursor: 'pointer',
            '&:hover': {
                border: 'solid 1px #DADDE8',
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#323236',
        }),

        dropdownIndicator: (provided) => ({
            ...provided,
            color: '#DADDE8',
            opacity: '1',
            cursor: 'pointer',
            '&:hover': {
                color: '#323236',
            },
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            opacity: '0',
        }),
        menu: (provided, state) => ({
            ...provided,
            marginTop: '0',
            padding: '0',
        }),
        option: (provided, state) => ({
            ...provided,
            cursor: state.isSelected ? '' : 'pointer',
            color: state.isSelected
                ? '#C2C7D7'
                : state.isDisabled
                ? '#C9CEDC'
                : '#000',
            backgroundColor: 'transparent',
            '&:hover': {
                backgroundColor: state.isSelected ? '#fff' : '#e6e6e6',
            },
        }),
    });

    // Show input when editable cell is active
    if (showEdit) {
        switch (id) {
            case 'monthly':
                return (
                    <div>
                        <div className="flex gap-1 items-center relative">
                            <input
                                name={id}
                                value={value}
                                className={`w-4 h-4 rounded ${
                                    value ? 'opacity-100' : 'opacity-0'
                                }`}
                                onChange={onChange}
                                type={'checkbox'}
                                checked={value}
                            />
                            <div
                                className={`absolute top-0 w-4 h-4 bg-white  border-solid rounded text-md border border-gray-300 outline-none ${
                                    value ? 'opacity-0' : 'opacity-100'
                                }`}
                                onClick={toggleValue}
                            ></div>
                            <p className="text-xs"> is monthly limit</p>
                        </div>
                        <small className="text-xs text-red-600">
                            {errorMessages[id]}
                        </small>
                    </div>
                );
            case 'customer':
                if (selectOptions?.length) {
                    return (
                        <div>
                            <CreatableSelect
                                isClearable
                                options={selectOptions}
                                isSearchable={true}
                                styles={setCustomersSelectStyle()}
                                onChange={onChange}
                                placeholder="Search or create"
                                value={selectOptions?.find(
                                    (option) => option?.value === value
                                )}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                menuPosition="absolute"
                            />
                            <small className="text-xs text-red-600">
                                {errorMessages[id]}
                            </small>
                        </div>
                    );
                }
            case 'hours':
            case 'name':
            case 'disctiption':
            default:
                return (
                    <div>
                        <input
                            name={id}
                            value={value}
                            placeholder={id === 'hours' ? 0 : 'Enter data'}
                            className={defaultStyles}
                            onChange={onChange}
                            type={id === 'hours' ? 'number' : 'text'}
                            min="0"
                        />
                        <small className="text-xs text-red-600">
                            {errorMessages[id]}
                        </small>
                    </div>
                );
        }
    }

    switch (id) {
        case 'monthly':
            return value ? 'monthly' : <span>&nbsp;</span>;
        case 'customer':
            return (
                selectOptions?.find((option) => option?.value === value)
                    ?.label || <span>&nbsp;</span>
            );
        case 'hours':
        case 'name':
        case 'disctiption':
        default:
            return value || <span>&nbsp;</span>;
    }
};

export default EditableCell;

